import { useAtomValue } from 'jotai';

import usePdpLastHoveredOptionsExtendedAtom from './usePdpLastHoveredOptionsExtendedAtom';

const usePdpLastHoveredOptionsExtended = () => {
  const pdpLastHoveredOptionsExtendedAtom = usePdpLastHoveredOptionsExtendedAtom();

  const pdpLastHoveredOptionsExtended = useAtomValue(
    pdpLastHoveredOptionsExtendedAtom
  );
  return pdpLastHoveredOptionsExtended;
};

export default usePdpLastHoveredOptionsExtended;
